import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, unref as _unref, mergeProps as _mergeProps } from "vue";
const _hoisted_1 = {
  class: "user-withdraw-list"
};
const _hoisted_2 = {
  class: "toolbox"
};
const _hoisted_3 = {
  class: "wrapper"
};

const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "团队", -1);

const _hoisted_5 = {
  class: "wrapper"
};

const _hoisted_6 = /*#__PURE__*/_createTextVNode("查询");

const _hoisted_7 = /*#__PURE__*/_createTextVNode("重置");

const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", {
  class: "info"
}, "线上支付账款自动分账至团队成员由个人自主至万药通app进行提现，记录可在此查看", -1);

const _hoisted_9 = /*#__PURE__*/_createTextVNode("提现记录");

import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { getVexTableProps } from '@/config';
import Axios from '@/request/createAxiosInstalce';
export default {
  name: 'user-withdraw',
  props: {
    supplierId: [Number, String]
  },

  setup(__props, {
    expose
  }) {
    const props = __props;
    const router = useRouter();
    onMounted(() => getSupplierList());
    const supplierId = ref('');
    const supplierList = ref([]);

    function getSupplierList() {
      Axios.get('/admin/split/rule/getLevelOneSupplierList.json').then(res => {
        supplierList.value = res.data.data;
      });
    }

    function reset() {
      supplierId.value = '';
      setTimeout(() => search(), 300);
    }

    const table = ref();
    const tableOptions = getVexTableProps({
      columns: [{
        title: '提现角色',
        field: 'participateRoleName'
      }, {
        title: '分账参与方',
        field: 'participateName'
      }, {
        title: '所属团队',
        field: 'supplierName'
      }, {
        title: '待提现金额',
        field: 'unWithdrawAmount'
      }, {
        title: '待入账金额',
        field: 'unEntryAmont'
      }, {
        title: '冻结金额',
        field: 'freezeAmont'
      }, {
        title: '提现笔数',
        field: 'withdrawNum'
      }, {
        title: '操作',
        slots: {
          default: 'operation'
        }
      }],
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => {
            return new Promise(resolve => {
              let params = {
                page: page.currentPage,
                pageSize: page.pageSize,
                supplierId: supplierId.value
              };
              Axios.get('/admin/split/withdraw/personalList.json', {
                params
              }).then(res => {
                if (!res.data.success) return;
                resolve({
                  total: res.data.data.total,
                  result: res.data.data.list
                });
              });
            });
          }
        }
      }
    });

    function initTable() {
      table.value.commitProxy('reload');
    }

    function toWithdraw(row) {
      let query = {
        participateId: row.participateId,
        participateRole: row.participateRole
      };
      router.push({
        name: 'sepaccountWithdrawHistory',
        query
      });
    }

    expose({
      initTable
    });
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_button = _resolveComponent("el-button");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createVNode(_component_el_select, {
        modelValue: supplierId.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => supplierId.value = $event),
        placeholder: "请选择团队",
        style: {
          "width": "300px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_option, {
          label: "全部",
          value: ""
        }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(supplierList.value, item => {
          return _openBlock(), _createBlock(_component_el_option, {
            label: item.supplierName,
            value: item.supplierId
          }, null, 8, ["label", "value"]);
        }), 256))]),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[1] || (_cache[1] = $event => table.value.commitProxy('reload'))
      }, {
        default: _withCtx(() => [_hoisted_6]),
        _: 1
      }), _createVNode(_component_el_button, {
        type: "primary",
        onClick: reset
      }, {
        default: _withCtx(() => [_hoisted_7]),
        _: 1
      })])]), _hoisted_8, _createVNode(_component_vxe_grid, _mergeProps({
        ref_key: "table",
        ref: table
      }, _unref(tableOptions)), {
        operation: _withCtx(({
          row
        }) => [_createVNode(_component_el_button, {
          type: "primary",
          size: "small",
          onClick: $event => toWithdraw(row)
        }, {
          default: _withCtx(() => [_hoisted_9]),
          _: 2
        }, 1032, ["onClick"])]),
        _: 1
      }, 16)]);
    };
  }

};